// Sort class names into real academic order (Nursery → LKG → UKG → 1 → 2 …),
// not the order students happen to appear in a list.

const PRE = {
  playgroup: -9, pg: -9, playhome: -9,
  prenursery: -8, ppn: -8,
  nursery: -7, nur: -7, nsy: -7,
  prekg: -6, kg: -6, kindergarten: -6, montessori: -6,
  lkg: -5, jrkg: -5, juniorkg: -5, pp1: -5, ppi: -5, "1stkg": -5,
  ukg: -4, srkg: -4, seniorkg: -4, pp2: -4, ppii: -4, "2ndkg": -4,
  prep: -3, preparatory: -3,
};

export function classRank(name) {
  const n = String(name || "").trim().toLowerCase().replace(/[\s._-]/g, "");
  if (n in PRE) return PRE[n];
  const m = n.match(/(\d{1,2})/);
  if (m) return parseInt(m[1], 10); // "1", "1st", "class 1", "grade 10"
  return 999; // unknown names fall to the end, kept in alpha order
}

export function sortClasses(list) {
  return [...new Set(list)]
    .filter(Boolean)
    .sort((a, b) => classRank(a) - classRank(b) || String(a).localeCompare(String(b)));
}
